import SettingFrame from "../../../../../components/@settings/SettingFrame";
import ListCountries from "../../../../../components/@region/countries/ListCountries";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function CountriesPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListCountries
                routeType={routeType}
            />
        </SettingFrame>
    )
}